import { GetWSMgr } from "@/Utils/StateLib";
import { ImportFilterFieldInput } from "./ImportFilterFieldInput";
import { isNullish, Select } from "@theorgchartdev/storybook";
import { useAsyncEffect } from "@/hooks/useAsyncEffect";
import { QQueryUniqueValues } from "@coreapp/CoreApp/QQueryUniqueValues";
import { Globals } from "@coreapp/CoreApp/Globals";
import { appstr } from "@coreapp/utils/appstr";

const BuildFieldValueOptions = (values, onClick) => {
  return (values ?? []).map(v => ({
    clickHandler: onClick,
    label: v,
    value: v
  }));
};

export const ImportFilterSeedInput = props => {
  const hasFieldSelected = !isNullish(props.importFilter?.field);

  const { data, loading } = useAsyncEffect(() => {
    if (isNullish(props.importFilter?.field)) {
      return [];
    }

    const wsMgr = GetWSMgr();
    if (!wsMgr) {
      return [];
    }

    return new Promise((resolve, reject) => {
      const callbackObj = {
        QueryUniqueValuesResponse: (success, _fieldName, _colWidth, results) => {
          if (success) {
            resolve(results);
            return;
          }

          reject();
        }
      };

      const dataQuery = new QQueryUniqueValues();
      dataQuery.InitQueryUniques(callbackObj);
      const accountName = wsMgr.GetAccountName();
      const user = wsMgr.GetUserName();
      dataQuery.SetParams(accountName, user, props.importFilter.field, props.chartConfig["ID"]);
      Globals._rfcMgr.QueueRFC(dataQuery);
    });
  }, [props.importFilter?.field]);

  const handleValueChange = ({ value }) => {
    const nextFilter = structuredClone(props.importFilter);
    nextFilter["seed"] = value;
    props.setImportFilter(nextFilter);
  };

  return (
    <>
      <ImportFilterFieldInput {...props} />
      <Select
        inputOnly={false}
        listProps={{
          enableSearch: true,
          noResultsText: appstr("nomatches"),
          inputProps: {
            placeholder: appstr("Find")
          }
        }}
        popoverProps={{
          flipOptions: {
            mainAxis: false
          }
        }}
        label={appstr("Value")}
        disabled={!hasFieldSelected || loading}
        value={props.importFilter["seed"]}
        options={BuildFieldValueOptions(data, handleValueChange)}
        dataTestId={`${props.dataTestIdPrefix}-seed-select`}
      />
    </>
  );
};
